<template>
  <div class="milenium-page">
    <div class="milenium-page-image-container" :class="{ 'milenium-page-image-container--error': error }">
      <img
        v-if="src"
        class="milenium-page-image"
        :src="src"
        :alt="page.sectionName"
        @error="waitAndRetry"
      >
    </div>
    <div class="milenium-page-footer mt-2">
      <h3 class="title">{{ $t('message.milenium.page') }} {{ page.pageNumber }}</h3>
      <h4 class="subheading" v-if="page.sectionName">{{ page.sectionName}}</h4>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    page: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      src: null,
      error: false,
    };
  },
  mounted() {
    this.src = this.page.previewImageUrl;
  },
  methods: {
    waitAndRetry() {
      this.error = true;
      this.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
      setTimeout(() => {
        this.error = false;
        this.src = this.page.previewImageUrl;
      }, 5000);
    },
  },
};
</script>

<style lang="stylus" scoped>
.milenium-page {
  transition: transform .2s
  padding: 12px

  &-image-container {
    position: relative;
    width: 100%;
    height: 300px;

    &--error {
      background-color: #ddd;

      &:before {
        content: '';
        box-sizing: border-box;
        position: absolute;
        top: 50%;
        left: 50%;
        width: 20px;
        height: 20px;
        margin-top: -10px;
        margin-left: -10px;
        border-radius: 50%;
        border: 2px solid #ccc;
        border-top-color: #000;
        animation: spinner .6s linear infinite;
      }
    }
  }

  &-image {
    width: 100%
    opacity: 0.7
    height: 300px
    object-fit: contain

    &:hover {
      opacity: 1
    }
  }

  &-footer {
    text-transform: uppercase
    text-align: center
  }

  &:hover {
    cursor: pointer
    transform: scale(1.05)
    background-color rgba(78, 130, 209, 0.1)
  }
}

@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}
</style>
